import React, { useEffect } from "react";
import { Container, Navbar, Nav, NavDropdown, Button, Image } from "react-bootstrap";
// import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import AlertModal from "./AlertModal";
import { useAuth } from "../context/AuthContext";

function Header() {
  const { isAuthenticated, logout, userInfo } = useAuth();
  const location = useLocation();


  const logoutHandler = () => {
    logout();
  };


  return (
    <header className="mx-5 ">
      <Navbar expand="lg" className="rounded-4 py-0 bg-" variant="dark" collapseOnSelect style={{ backgroundColor: '#1D4D2C', direction: 'rtl' }}>
        <Container fluid>
          <Navbar.Brand as={Link} to="/" className="fs-2">
            نظام إدارة المشاتل
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto my-2 my-lg-0 h-100" style={{ maxHeight: '150px' }}>
              {/* <Nav.Link as={Link} to="/">Home</Nav.Link> */}


            </Nav>

            <div className="d-flex justify-content-center align-items-center mt-5 mt-md-0 text-white">
              {isAuthenticated ? (
                <div className="d-flex justify-content-between align-items-center " style={{ minWidth: '150px' }}>
                  <NavDropdown className="text-white pe-5" title={userInfo.username} id="username">
                    <NavDropdown.Item as={Link} to="/staff/profile">الملف الشخصي</NavDropdown.Item>
                    <AlertModal
                      customebutton={<NavDropdown.Item>تسجيل الخروج</NavDropdown.Item>}
                      myaction={logoutHandler}
                      title="تسجيل الخروج"
                      message="هل تريد تسجيل الخروج؟"
                      savetitle="تسجيل الخروج"
                      variant="danger"
                    />
                  </NavDropdown>
                  <Link >
                    <Image className="p-1" src={`${process.env.REACT_APP_API_URL}/${userInfo.image}`} alt={userInfo.username}

                      roundedCircle style={{ width: '50px', height: '50px' }} />
                  </Link>
                </div>
              ) : (
                <div className="d-flex justify-content-between align-items-center" style={{ minWidth: '150px' }}>
                  {/* <Nav.Link as={Link} to="/register" className="text-white">Sign Up</Nav.Link> */}
                  <Button as={Link} to="/dashboard/login" className="btn bg-white text-dark rounded-pill fw-bold">Sign In</Button>
                </div>
              )}
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
}

export default Header;